module.exports = __webpack_public_path__ + "img/elo.f3067912.svg";